import { TabContext, TabList } from "@mui/lab";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Tab,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import fromImg from "./../../../assets/icons/forms.png";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs, { Dayjs } from "dayjs";
import Personels from "../../restaurantsetup/components/KYCForm/Personels/Personels.tsx";
import CourierDocuments from "./CourierDocuments/CourierDocuments.tsx";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import LoadingView from "../../components/LoadingView/LoadingView";
import jwtDecode from "jwt-decode";

const CourierRegistration = () => {
  const [Loading, setLoading] = React.useState(false);
  const [Tabvalue, setTabValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newTabValue: string) => {
    setTabValue(newTabValue);
  };
  const [menuSelection, setMenu] = useState(1);
  const [radiovalue, setRadioValue] = React.useState("Sole");
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioValue((event.target as HTMLInputElement).value);
    console.log((event.target as HTMLInputElement).value);
  };

  const [handleDeliverVehiclevalue, sethandleDeliverVehiclevalue] =
    React.useState("Bike");
  const [bikeSelection, setbikeSelection] = React.useState(true);
  const [motorbikeSelection, setMotorbikeSelection] = React.useState(false);
  const [carSelection, setCarSelection] = React.useState(false);
  const handleDeliveryRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if ((event.target as HTMLInputElement).value == "Bike") {
      setbikeSelection(!bikeSelection);
    } else if ((event.target as HTMLInputElement).value == "MotoBike") {
      setMotorbikeSelection(!motorbikeSelection);
    } else if ((event.target as HTMLInputElement).value == "Car") {
      setCarSelection(!carSelection);
    }
    sethandleDeliverVehiclevalue((event.target as HTMLInputElement).value);
    console.log((event.target as HTMLInputElement).value);
  };

  const [LegalNamerror, setLegalNamerror] = useState(false);
  const [RegisteredCountry, setRegisteredCountry] = useState(false);
  const [comapnyRegistrationNumber, setcomapnyRegistrationNumber] =
    useState(false);
  const [State, setState] = useState(false);
  const [Tradename, setTradename] = useState(false);
  const [City, setCity] = useState(false);
  const [StreetAddress, setStreetAddress] = useState(false);
  const [houseNumber, setHouseNumber] = useState(false);
  const [vat, setVat] = useState(false);
  const [ZipCode, setZipCode] = useState(false);
  const [IncorporateDate, setIncorporateDate] = useState(false);
  const [BiilingAddress, setBiilingAddress] = useState(false);
  const [CountryCode, setCountryCode] = useState(false);

  //payment acceptance details start
  const [AccountholderGBP, setAccountholderGBP] = useState(false);
  const [Sortcode, setSortcode] = useState(false);
  const [AccountNumber, setAccountNumber] = useState(false);
  const [AccountholderEUR, setAccountholderEUR] = useState(false);
  const [Ibn, setIbn] = useState(false);

  const [courierForm, setcourierForm] = useState({
    companyDetail: {
      Id: "a",
      LegalName: "a",
      RegisteredCountry: "a",
      RegistrationNumber: "a",
      State: "a",
      TradeName: "a",
      City: "a",
      HouseNumber: "a",
      VatOrTaxNumber: "Not Provided",
      Postalcode: "a",
      BillingAddress: "a",
      CountryCode: "a",
      IsActive: true,
      CreatorId: "a",
      RegisteredStreetAddress: "a",
    },
  });
  const [value, setValue] = React.useState<Dayjs | null>(dayjs("2022-04-17"));

  const [Obj, setObj] = useState({
    Id: "paymentID",
    CourierId: "1223",
    SettlementCurrencytype: 2,
    AccountHolder: "",
    ShortCode: "",
    AccountNumber: "",
    IBAN: "123",
    IsActive: false,
    CreationId: "2424",
    CreationDate: new Date(),
    ModifierId: "243214",
    ModificationDate: new Date(),
  });
  const [ObjEUR, setObjEUR] = useState({
    Id: "paymentID",
    CourierId: "1223",
    SettlementCurrencytype: 1,
    AccountHolder: "",
    ShortCode: "",
    AccountNumber: "",
    IBAN: "",
    IsActive: false,
    CreationId: "2424",
    CreationDate: new Date(),
    ModifierId: "243214",
    ModificationDate: new Date(),
  });
  const [directorOne, setdirectorOne] = React.useState({});
  const PersonOneValue = (props) => {
    console.log(props);
    props.rank = 1;
    setdirectorOne(props);
    // setDirectors([...directors, directorOne])
  };
  const [tableData, setTableData] = useState([]);
  const dataFromDocument = (props) => {
    console.log(props);
    setTableData(props);
  };

  const [sendableobj, setsendableobj] = useState({});

  const validateEmail = (props) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return emailPattern.test(props);
  };

  const submitData = async () => {
    setLoading(true);
    var valid = true;
    //compnaydetails validation start
    console.log(courierForm.companyDetail);

    if (radiovalue == "Limited") {
      if (courierForm.companyDetail.LegalName.trim() === "a") {
        setLegalNamerror(true);
        valid = false;
      }
      if (courierForm.companyDetail.RegisteredCountry.trim() === "a") {
        setRegisteredCountry(true);
        valid = false;
      }
      if (courierForm.companyDetail.State.trim() === "a") {
        setState(true);
        valid = false;
      }
      if (courierForm.companyDetail.TradeName.trim() === "a") {
        setTradename(true);
        valid = false;
      }
      if (courierForm.companyDetail.City.trim() === "a") {
        setCity(true);
        valid = false;
      }
      if (courierForm.companyDetail.HouseNumber.trim() === "a") {
        setHouseNumber(true);
        valid = false;
      }
      if (courierForm.companyDetail.VatOrTaxNumber.trim() === "a") {
        // setVat(true);
        // valid = false;
        courierForm.companyDetail.VatOrTaxNumber = "Not Added";
      }
      if (courierForm.companyDetail.Postalcode.trim() === "a") {
        setZipCode(true);
        valid = false;
      }

      if (courierForm.companyDetail.BillingAddress.trim() === "a") {
        setBiilingAddress(true);
        valid = false;
      }
      if (courierForm.companyDetail.CountryCode.trim() === "a") {
        setCountryCode(true);
        valid = false;
      }
      if (courierForm.companyDetail.RegisteredStreetAddress.trim() === "a") {
        setStreetAddress(true);
        valid = false;
      }
    }

    //payment acceptance details start
    if (Obj.AccountHolder.trim() === "") {
      setAccountholderGBP(true);
      valid = false;
    }
    if (Obj.ShortCode.trim() === "") {
      setSortcode(true);
      valid = false;
    }
    if (Obj.AccountNumber.trim() === "") {
      setAccountNumber(true);
      valid = false;
    }
    if (ObjEUR.AccountHolder.trim() === "") {
      setAccountholderEUR(true);
      valid = false;
    }
    if (ObjEUR.IBAN.trim() === "") {
      setIbn(true);
      valid = false;
    }

    if (
      directorOne.FirstName != undefined &&
      directorOne.LastName != undefined &&
      directorOne.DOB != null &&
      directorOne.HomeAddress != undefined &&
      directorOne.ZipCode != undefined &&
      directorOne.City != undefined &&
      directorOne.Country != undefined &&
      directorOne.PhoneNumber != undefined &&
      directorOne.EmailAddress != undefined &&
      directorOne.PassportOrIdNumber != undefined &&
      directorOne.FirstName != "" &&
      directorOne.LastName != "" &&
      directorOne.DOB != "" &&
      directorOne.HomeAddress != "" &&
      directorOne.ZipCode != "" &&
      directorOne.City != "" &&
      directorOne.Country != "" &&
      directorOne.PhoneNumber != "" &&
      directorOne.EmailAddress != "" &&
      directorOne.PassportOrIdNumber != ""
    ) {
      if (
        directorOne.PhoneNumber.length != 10 &&
        directorOne.PhoneNumber.length != 11
      ) {
        valid = false;
        toast.error("Phone number must be of 10 or 11 digits on Director 1", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      if (!validateEmail(directorOne.EmailAddress)) {
        valid = false;
        toast.error("Email isn't valid on Director 1", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      valid = false;
      toast.error("Please fill up missing field on Personnels", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (tableData.length == 0) {
      valid = false;
      toast.error("Please upload missing documents", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      tableData.map((dt, i) => {
        if (
          dt.Name == "Valid driving license" ||
          dt.Name == "Insurance documents proof "
        ) {
          console.log("if");
          if (motorbikeSelection || carSelection) {
            if (dt.File.length == 0) {
              valid = false;
              toast.error("Please upload missing documents on " + dt.Name, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          } else {
            dt.DocumentUrls = ["none"];
          }
        } else {
          console.log("else");
          if (dt.File.length == 0) {
            valid = false;
            toast.error("Please upload missing documents on " + dt.Name, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      });
    }
    if (valid) {
      var month = parseInt(value.$M + 1);
      var day = value.$y + "-" + month + "-" + value.$D;
      var mydate = new Date(day);

      console.log(mydate);
      courierForm.companyDetail.IncorporationDate = mydate;
      const token = localStorage.getItem("gotasteadmintoken");
      var decodedData = {};
      if (token != null) {
        try {
          decodedData = jwtDecode(token);
          console.log(decodedData);
        } catch (error) {}
      }
      var obj = {
        courierCompanyDetails: courierForm.companyDetail,
        courierPersonnel: directorOne,
        paymentDetails: [],
        documnets: [],
        isBike: bikeSelection,
        isMotorBike: motorbikeSelection,
        isCar: carSelection,
        businessType: radiovalue,
      };
      console.log(courierForm.companyDetail);
      console.log(obj.courierCompanyDetails);
      obj.courierCompanyDetails.CreatorId = decodedData.UserId;
      obj.courierPersonnel.CreatorId = decodedData.UserId;
      obj.courierPersonnel.CourierId = "a";
      obj.courierPersonnel.ModifierId = decodedData.UserId;
      obj.courierPersonnel.PersonnelType = "Owner";
      obj.courierCompanyDetails.CourierId = "a";
      obj.courierCompanyDetails.ModifierId = decodedData.UserId;

      obj.paymentDetails.push(ObjEUR);
      obj.paymentDetails.push(Obj);
      var res = await fileupload();
      console.log(obj);
      obj.documnets = res;
      setsendableobj(obj);
      await postToDb(obj);
    } else {
      setLoading(false);
    }
  };

  const postToDb = async (obj) => {
    console.log(obj);
    await axios({
      method: "post",
      url: apiAddress + "/api/Courier",
      data: obj,
    })
      .then((response) => {
        console.log(response);
        setLoading(false);
        toast.success("Successfully submited ", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        localStorage.removeItem("gotasteadmintoken");
        window.location.href = `/`;
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Some thing went wrong", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const apiAddress = process.env.REACT_APP_SECRET;
  const fileupload = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwtDecode(token);
        console.log(decodedData);
      } catch (error) {}
    }
    for (let i = 0; i < tableData.length; i++) {
      const formData = new FormData();
      if (
        tableData[i].Name == "Valid driving license" ||
        tableData[i].Name == "Insurance documents proof "
      ) {
        if (motorbikeSelection || carSelection) {
          tableData[i].File.forEach((file) => {
            formData.append("file", file);
          });
          await axios({
            method: "post",
            url: apiAddress + "/api/FileUpload/addMultiplefile",
            headers: {
              "Content-Type": "multipart/form-data", // <- HERE
            },
            data: formData,
          })
            .then((response) => {
              tableData[i].DocumentUrls = response.data;
              tableData[i].DocumentUrl = "none";
              tableData[i].FileName = tableData[i].Name;
              tableData[i].CreatorId = decodedData.UserId;
              tableData[i].ModifierId = decodedData.UserId;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          tableData[i].DocumentUrls = ["none"];
          tableData[i].DocumentUrl = "none";
          tableData[i].FileName = tableData[i].Name;
          tableData[i].CreatorId = decodedData.UserId;
          tableData[i].ModifierId = decodedData.UserId;
        }
      } else {
        tableData[i].File.forEach((file) => {
          formData.append("file", file);
        });
        await axios({
          method: "post",
          url: apiAddress + "/api/FileUpload/addMultiplefile",
          headers: {
            "Content-Type": "multipart/form-data", // <- HERE
          },
          data: formData,
        })
          .then((response) => {
            tableData[i].DocumentUrls = response.data;
            tableData[i].DocumentUrl = "none";
            tableData[i].FileName = tableData[i].Name;
            tableData[i].CreatorId = decodedData.UserId;
            tableData[i].ModifierId = decodedData.UserId;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    return tableData;
  };
  // useEffect(() => {
  //     console.log("object");
  //     postToDb(sendableobj);
  // }, [isAllFileUploaded])

  return (
    <>
      <ToastContainer />
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />
      <div
        className={`d-flex `}
        style={{
          marginRight: "1rem",
          marginTop: "10px",
          gap: "10px",
          position: "absolute",
          right: "1rem",
        }}
      >
        <button
          className="btn btn-success"
          style={{ marginRight: "1rem", cursor: "pointer" }}
          onClick={() => {
            localStorage.removeItem("gotasteadmintoken");
            localStorage.removeItem("permissions");
            window.location.href = `/`;
          }}
        >
          Log Out
        </button>
      </div>
      <div className="d-flex">
        <div className={``}>
          <div className="searchBoxForProduct" style={{ padding: "10px" }}>
            {/* <TextAreaComponents label={"Search"} id={4} /> */}
            <input
              type="text"
              placeholder="Search"
              className="form-control searchBar"
            />
          </div>

          <div
            className="scrollable-div"
            style={{ width: "13rem", height: "92vh" }}
          >
            <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
              <b> Form</b>
            </h6>
            <hr className="" style={{ margin: ".5rem" }} />
            <div
              className={`courier_registration__menuItem ${menuSelection == 1 ? "active" : ""}`}
              style={{
                width: "100%",
                height: "3rem",
                transition: "background-color 0.3s",
              }}
              onClick={() => setMenu(1)}
            >
              <div
                className=" d-flex justify-content-start align-items-center ms-3"
                style={{ height: "100%", gap: "10px" }}
              >
                <img
                  src={fromImg}
                  alt="leo"
                  style={{ width: "1.2rem", height: "1.2rem" }}
                />
                <p
                  style={{
                    color: "black",
                    fontWeight: "500",
                    marginBottom: "0px",
                    fontSize: "13px",
                  }}
                >
                  Fill Up Courier Form
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`p-4 ${menuSelection == 1 ? "" : "d-none"}`}
          style={{ height: "100vh", width: "100vw" }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ flexDirection: "column" }}
          >
            <h3 className="headerName" style={{ fontSize: "1.9rem" }}>
              Go Taste
            </h3>
            <h3 className="headerName" style={{ fontSize: "1.9rem" }}>
              Courier Registration Form
            </h3>
          </div>
          <div className="Kyctabview">
            <TabContext value={Tabvalue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleChange}>
                  <Tab label="Courier Registration form" value="1" />
                  <Tab label="Documents" value="2" />
                </TabList>
              </Box>
            </TabContext>
          </div>
          <div className={`${Tabvalue == "1" ? "p-3 kycform " : "d-none"} `}>
            <div className="p-3"></div>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={4}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <h5 className="headerName" style={{ fontSize: "1.5rem" }}>
                    {" "}
                    How you want to deliver?
                  </h5>
                </div>
              </Grid>
              <Grid item xs={8} sx={{ padding: "0.5rem" }}>
                <FormGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={handleDeliveryRadioChange}
                >
                  <FormControlLabel
                    value="Bike"
                    control={<Checkbox defaultChecked />}
                    label="Bike"
                  />
                  <FormControlLabel
                    value="MotoBike"
                    control={<Checkbox />}
                    label="Motor Bike"
                  />
                  <FormControlLabel
                    value="Car"
                    control={<Checkbox />}
                    label="Car"
                  />
                </FormGroup>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={4}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <h5 className="headerName" style={{ fontSize: "1.5rem" }}>
                    {" "}
                    Business type
                  </h5>
                </div>
              </Grid>
              <Grid item xs={8} sx={{ padding: "0.5rem" }}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={radiovalue}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel
                    value="Sole"
                    control={<Radio />}
                    label="Sole Trader"
                  />
                  <FormControlLabel
                    value="Limited"
                    control={<Radio />}
                    label="Limited Company"
                  />
                </RadioGroup>
              </Grid>
            </Grid>
            {radiovalue == "Limited" ? (
              <>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={3}>
                    <div
                      className="d-flex"
                      style={{ paddingTop: "1rem", gap: "10px" }}
                    >
                      <h3 className="headerName" style={{ fontSize: "1.5rem" }}>
                        {" "}
                        Company Details{" "}
                      </h3>
                    </div>
                  </Grid>
                  <Grid item xs={9} sx={{ padding: "0.5rem" }}></Grid>
                </Grid>
                <Grid
                  container
                  spacing={5}
                  sx={{
                    padding: "0.5rem",
                    paddingLeft: "10rem",
                    paddingRight: "10rem",
                    paddingTop: "2rem",
                  }}
                >
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Legal Company Name"}
                      value={(props) => {
                        courierForm.companyDetail.LegalName = props;
                        setLegalNamerror(false);
                      }}
                      error={LegalNamerror}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Registration country"}
                      value={(props) => {
                        courierForm.companyDetail.RegisteredCountry = props;
                        setRegisteredCountry(false);
                      }}
                      error={RegisteredCountry}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Company registration number"}
                      value={(props) => {
                        courierForm.companyDetail.RegistrationNumber = props;
                        setcomapnyRegistrationNumber(false);
                      }}
                      error={comapnyRegistrationNumber}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"State"}
                      value={(props) => {
                        courierForm.companyDetail.State = props;
                        setState(false);
                      }}
                      error={State}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Registered DBA (doing business as)/ trade name"}
                      value={(props) => {
                        courierForm.companyDetail.TradeName = props;
                        setTradename(false);
                      }}
                      error={Tradename}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"City"}
                      value={(props) => {
                        courierForm.companyDetail.City = props;
                        setCity(false);
                      }}
                      error={City}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Registered street address"}
                      value={(props) => {
                        courierForm.companyDetail.RegisteredStreetAddress =
                          props;
                        setStreetAddress(false);
                      }}
                      id={6}
                      error={StreetAddress}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"House number"}
                      value={(props) => {
                        courierForm.companyDetail.HouseNumber = props;
                        setHouseNumber(false);
                      }}
                      error={houseNumber}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"VAT / Tax identification number (If Applicable)"}
                      value={(props) => {
                        courierForm.companyDetail.VatOrTaxNumber = props;
                        setVat(false);
                      }}
                      error={vat}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Postal code / Zip code"}
                      value={(props) => {
                        courierForm.companyDetail.Postalcode = props;
                        setZipCode(false);
                      }}
                      error={ZipCode}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      sx={{ width: "100%", padding: "0" }}
                    >
                      <DemoContainer
                        components={["DatePicker"]}
                        sx={{ width: "100%", padding: "0" }}
                      >
                        <DatePicker
                          label="Incorporation Date"
                          sx={{ width: "100%", padding: "0" }}
                          onChange={(newValue) => setValue(newValue)}
                          className="custom-textField custom-DateField"
                          maxDate={dayjs(new Date())}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={
                        "Billing address (if differ from registered address)"
                      }
                      value={(props) => {
                        courierForm.companyDetail.BillingAddress = props;
                        setBiilingAddress(false);
                      }}
                      error={BiilingAddress}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                  <Grid item xs={6}>
                    <TextAreaComponents
                      label={"Country Code"}
                      value={(props) => {
                        courierForm.companyDetail.CountryCode = props;
                        setCountryCode(false);
                      }}
                      error={CountryCode}
                      id={6}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
              </>
            ) : (
              ""
            )}
            <div
              className="d-flex  "
              style={{
                flexDirection: "column",
                marginTop: "2rem",
                padding: ".5rem",
              }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <h3 className="headerName" style={{ fontSize: "1.5rem" }}>
                  {" "}
                  Personal Details{" "}
                </h3>
              </div>
              <div
                style={{
                  padding: "0.5rem",
                  paddingLeft: "8rem",
                  paddingRight: "8rem",
                  paddingTop: "1rem",
                }}
              >
                <Personels title={"Person 1"} val={PersonOneValue} />
              </div>
            </div>

            <div
              className="d-flex align-items-center"
              style={{ gap: "10px", marginTop: "2rem" }}
            >
              <h3 className="headerName" style={{ fontSize: "1.5rem" }}>
                {" "}
                Payment Acceptance Details{" "}
              </h3>
            </div>

            <div
              className="d-flex align-items-center"
              style={{ gap: "10px", marginTop: "10px" }}
            >
              <h3
                className="headerName"
                style={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                {" "}
                Settlement currency: <b>GBP</b>{" "}
              </h3>
            </div>
            <Grid
              container
              spacing={2}
              sx={{
                padding: "0.5rem",
                paddingLeft: "10rem",
                paddingRight: "10rem",
                paddingTop: "1rem",
              }}
            >
              <Grid item xs={6}>
                <TextAreaComponents
                  label={"Account holder(beneficiary) "}
                  value={(props) => {
                    Obj.AccountHolder = props;
                    setAccountholderGBP(false);
                  }}
                  error={AccountholderGBP}
                  id={6}
                ></TextAreaComponents>
              </Grid>
              <Grid item xs={6}>
                <TextAreaComponents
                  label={"Sort Code "}
                  value={(props) => {
                    Obj.ShortCode = props;
                    setSortcode(false);
                  }}
                  error={Sortcode}
                  id={6}
                ></TextAreaComponents>
              </Grid>
              <Grid item xs={6}>
                <TextAreaComponents
                  label={"Account Number "}
                  value={(props) => {
                    Obj.AccountNumber = props;
                    setAccountNumber(false);
                  }}
                  error={AccountNumber}
                  id={6}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <div
              className="d-flex align-items-center"
              style={{ gap: "10px", marginTop: "10px" }}
            >
              <h3
                className="headerName"
                style={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                {" "}
                Settlement currency: <b>EUR</b>{" "}
              </h3>
            </div>
            <Grid
              container
              spacing={2}
              sx={{
                padding: "0.5rem",
                paddingLeft: "10rem",
                paddingRight: "10rem",
                paddingTop: "1rem",
              }}
            >
              <Grid item xs={6}>
                <TextAreaComponents
                  label={"Account holder(beneficiary) "}
                  value={(props) => {
                    ObjEUR.AccountHolder = props;
                    setAccountholderEUR(false);
                  }}
                  error={AccountholderEUR}
                  id={6}
                ></TextAreaComponents>
              </Grid>
              <Grid item xs={6}>
                <TextAreaComponents
                  label={"IBAN"}
                  value={(props) => {
                    ObjEUR.IBAN = props;
                    setIbn(false);
                  }}
                  error={Ibn}
                  id={9}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={12}>
                <div
                  className="d-flex justify-content-end"
                  style={{ gap: "10px" }}
                >
                  <Button
                    className="btn-custom-submit"
                    onClick={() => {
                      setTabValue("2");
                    }}
                  >
                    Next
                  </Button>
                  {/* <Button className="btn-custom-submit" onClick={() => { submitData() }}>Submit</Button> */}
                </div>
              </Grid>
            </Grid>
          </div>
          <div className={`${Tabvalue == "2" ? "p-3" : "d-none"} `}>
            <CourierDocuments
              DeliverVehiclevalue={handleDeliverVehiclevalue}
              parentData={dataFromDocument}
              carSelection={carSelection}
              motorbikeSelection={motorbikeSelection}
            />
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={12}>
                <div
                  className="d-flex justify-content-end"
                  style={{ gap: "10px" }}
                >
                  <Button
                    className="btn-custom-submit"
                    onClick={() => {
                      setTabValue("1");
                    }}
                  >
                    Previous
                  </Button>
                  <Button
                    className="btn-custom-submit"
                    onClick={() => {
                      submitData();
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourierRegistration;
